export default {"src":"/accounts/_next/static/media/biodiversityCircle.eda45ec5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};